import { createApp } from "vue";
import App from "./App.vue";
import { createMetaManager } from "vue-meta"; // 메타정보를 설정하기 위한 함수
import AOS from "aos";
import "aos/dist/aos.css";

export const app = createApp(App);
app.AOS = new AOS.init();
app.use(createMetaManager()).use(AOS).mount("#app");
